import Paper from "@mui/material/Paper";

import { isMobile } from "react-device-detect";

import ProposicaoAcontecimentos from "./../../../proposicao/_components/acontecimentos/ProposicaoAcontecimentos";
import TabPanel from "../../../../components/carousel/TabPanel";


const ProposicaoCarouselTabsAcontecimentos = (props: { id_proposicao: number, activeTab: any, index: number, id_permissao: number }) => {
    return (
        <TabPanel value={props.activeTab} index={props.index}>
            <Paper style={{ borderRadius: "6px", paddingTop: `${isMobile ? "0px" : "30px"}`, }}>
                <ProposicaoAcontecimentos id_proposicao={props.id_proposicao} index={props.index} activeTab={props.activeTab} id_permissao={props.id_permissao} />
            </Paper>
        </TabPanel>
    );
};

export default ProposicaoCarouselTabsAcontecimentos;
